module.exports = __webpack_public_path__ + "img/icon-close2.8eaf91bc.png";